import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpIconComponent } from './icon.component';
import {
  ChevronLeftIconComponent,
  ChevronRightIconComponent,
  HomeIconComponent,
  InfoIconComponent,
  OpCursorRectangleSelectIconComponent,
  OpCursorSelectIconComponent,
  OpEnterpriseAddonsIconComponent,
  OpEraseIconComponent,
  OpFirstPersonViewIconComponent,
  OpGridMenuIconComponent,
  OpOrthographicPerspectiveIconComponent,
  OpResizerVerticalLinesIconComponent,
  OpScissorsIconComponent,
  OpThreedReturnDefaultIconComponent,
  OpViewFitToIconComponent,
  OpViewModalIconComponent,
  OpViewThreedIconComponent,
  PackageIconComponent,
  PersonIconComponent,
  ScreenFullIconComponent,
  ShareAndroidIconComponent,
  StarFillIconComponent,
  StarIconComponent,
  XIconComponent,
} from '@openproject/octicons-angular';

@NgModule({
  imports: [
    CommonModule,

    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    HomeIconComponent,
    InfoIconComponent,
    OpCursorRectangleSelectIconComponent,
    OpCursorSelectIconComponent,
    OpEnterpriseAddonsIconComponent,
    OpEraseIconComponent,
    OpFirstPersonViewIconComponent,
    OpGridMenuIconComponent,
    OpOrthographicPerspectiveIconComponent,
    OpResizerVerticalLinesIconComponent,
    OpScissorsIconComponent,
    OpThreedReturnDefaultIconComponent,
    OpViewFitToIconComponent,
    OpViewModalIconComponent,
    OpViewThreedIconComponent,
    PackageIconComponent,
    PersonIconComponent,
    ScreenFullIconComponent,
    ShareAndroidIconComponent,
    StarFillIconComponent,
    StarIconComponent,
    XIconComponent,
  ],
  declarations: [
    OpIconComponent,
  ],
  providers: [],
  exports: [
    OpIconComponent,

    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    HomeIconComponent,
    InfoIconComponent,
    OpCursorRectangleSelectIconComponent,
    OpCursorSelectIconComponent,
    OpEnterpriseAddonsIconComponent,
    OpEraseIconComponent,
    OpFirstPersonViewIconComponent,
    OpGridMenuIconComponent,
    OpOrthographicPerspectiveIconComponent,
    OpResizerVerticalLinesIconComponent,
    OpScissorsIconComponent,
    OpThreedReturnDefaultIconComponent,
    OpViewFitToIconComponent,
    OpViewModalIconComponent,
    OpViewThreedIconComponent,
    PackageIconComponent,
    PersonIconComponent,
    ScreenFullIconComponent,
    ShareAndroidIconComponent,
    StarFillIconComponent,
    StarIconComponent,
    XIconComponent,

  ],
})
export class IconModule {}
